import React, { useEffect } from "react";

import { Filters, IFilterValues, IUserFilters } from "component-library";
import { IMakeSuggestionsPerformersStatsResponse } from "models/suggestion";

import "./MakeSuggestionsFilterControl.scss";

interface IMakeSuggestionsFilterControlProps {
  stats: IMakeSuggestionsPerformersStatsResponse;
  filters: IUserFilters<IFilterValues>;
  loadCards: (withSuggestions: boolean) => void;
  withSuggestions: boolean;
}

const MakeSuggestionsFilterControl: React.FC<
  IMakeSuggestionsFilterControlProps
> = ({ filters, stats, loadCards, withSuggestions }) => {
  useEffect(() => {
    loadCards(withSuggestions);
  }, [filters.values, loadCards, withSuggestions]);

  if (filters.isLoading) return null;

  return (
    <div className="make-suggestions-filter-control">
      <Filters {...filters} stats={stats} />
    </div>
  );
};

export default MakeSuggestionsFilterControl;
